// Environment configuration loader
import developmentConfig from './env.development';
import productionConfig from './env.production';

// Determine which environment we're in
const isProduction = process.env.NODE_ENV === 'production';

// Export the appropriate configuration
const env = isProduction ? productionConfig : developmentConfig;

console.log(`Running in ${isProduction ? 'production' : 'development'} mode`);
console.log(`API URL: ${env.API_URL}`);

export default env;
